import { CadastroUsuarioModel } from "@/models/administracao/usuario/CadastroUsuarioModel";
import { authApi } from "@/api/AuthApi";
import { RetornoMensagemDTO } from "@/api/cadastro/saude/RetornoMensagemDTO";
import { FiltroCadastroUsuarioModel } from "@/models/administracao/usuario/FiltroCadastroUsuarioModel";
import { FiltroUsuariosDTO } from "@/api/auth/FiltroUsuariosDTO";
import { CadastroUsuarioPaginationModel } from "@/models/administracao/usuario/CadastroUsuarioPaginationModel";
import { CadastroUsuarioPagedResultDTO } from "@/api/auth/CadastroUsuarioPagedResultDTO";
import { gruposList, GRUPO_DEFAULT } from "@/models/administracao/usuario/GrupoModel";
import { UsuarioAdministrativoDTO } from "@/api/auth/UsuarioAdministrativoDTO";

class CadastroUsuarioService {
  salvarUsuario(cadastroUsuario: CadastroUsuarioModel): Promise<RetornoMensagemDTO> {
    if(!!cadastroUsuario.id && cadastroUsuario.id > 0) {
      return authApi.alterarUsuario({
        id: cadastroUsuario.id,
        nome: cadastroUsuario.nome,
        email: cadastroUsuario.nomeUsuario,
        grupos: [cadastroUsuario.grupo.nomeIntegracao],
      });
    } else {

      return authApi.salvarUsuario({
        nome: cadastroUsuario.nome,
        email: cadastroUsuario.nomeUsuario,
        grupos: [cadastroUsuario.grupo.nomeIntegracao],
      });
    }
  }

  excluirUsuario(idUsuario: number): Promise<RetornoMensagemDTO> {
    return authApi.excluirUsuario(idUsuario);
  }

  obterusuario(idUsuario: number): Promise<CadastroUsuarioModel> {
    return authApi.obterusuario(idUsuario).then((usuarioDTO: UsuarioAdministrativoDTO) => {
      const cadastroUsuarioModel: CadastroUsuarioModel = {
        id: usuarioDTO.id,
        nome: usuarioDTO.nome,
        nomeUsuario: usuarioDTO.email,
        grupo: gruposList.find((grupo) => grupo.nomeIntegracao === usuarioDTO.grupos[0]) || GRUPO_DEFAULT(),
      };
      return cadastroUsuarioModel;
    });
  }

  pesquisarUsuarios(filtro: FiltroCadastroUsuarioModel): Promise<CadastroUsuarioPaginationModel> {
    const filtroDTO: FiltroUsuariosDTO = {
      username: filtro.email,
      nome: filtro.nome,
      grupo: filtro.grupo?.nomeIntegracao,
      page: !!filtro.options.page ? filtro.options.page - 1 : 0,
      size: filtro.options.itemsPerPage,
    };
    console;

    return authApi.pesquisarUsuarios(filtroDTO).then((cadastroUsuarioPagedResultDTO: CadastroUsuarioPagedResultDTO) => {
      const model: CadastroUsuarioPaginationModel = {
        conteudo:
          cadastroUsuarioPagedResultDTO.content?.map((dto) => {
            const cadastroModel: CadastroUsuarioModel = {
              id: dto.id,
              nome: dto.nome,
              nomeUsuario: dto.email,
              grupo: gruposList.find((g) => g.nomeIntegracao === dto.grupos[0]) || GRUPO_DEFAULT(),
            };
            return cadastroModel;
          }) || [],
        page: filtro.options.page,
        itemsPerPage: filtro.options.itemsPerPage,
        itemsLength: cadastroUsuarioPagedResultDTO.totalElements,
      };
      return model;
    });
  }
}

export const cadastroUsuarioService: CadastroUsuarioService = new CadastroUsuarioService();
